import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const updatePackage = createAction(ACTION.UPDATE_PACKAGE_PARAM.REQUEST, (id, data, cb) => ({id, data, cb}));
export const clearState = createAction(ACTION.CLEAR_STATE, id => ({id}));
export const resetError = createAction(ACTION.RESET_ERROR, (id, params) => ({id, params}));